
















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { AdminDTO } from '../../../src_server/entity/dto/AdminDTO';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import PageNation from '../../components/organisms/PageNation.vue';
import SortTh from '../../components/atoms/SortTh.vue';
import { Sorter } from '../../utils/Sorter';
import AdminRow from './AdminRow.vue';
import AdminInfoMaintenance from './AdminInfoMaintenance.vue';
import NoData from './NoData.vue';
import { buildingData } from '../../../src_server/entity/master/buildingData';
import { AdminService } from '../../biz/remote/AdminService';

@Component({ components: { CommonDialog, PageNation, SortTh, AdminRow, AdminInfoMaintenance, NoData } })
export default class AdminMasterPage extends Vue {
  private selectedRow: AdminDTO = new AdminDTO();
  private adminRows: AdminDTO[] = []; // フィルタリング後の全行
  private dispRows: AdminDTO[] = []; // ページで表示中の行
  private selectedTeacher = {};

  // デフアカオンラインとテスト校舎以外（デフアカデミー）の校舎データを返す
  get buildings() {
    return buildingData.filter((d) => d.building_id !== 'co01' && d.building_id !== 'test');
  }

  async addAdmin() {
    const dialog = this.$refs['admin_detail_dialog'] as AdminInfoMaintenance;
    dialog.show(new AdminDTO(), 'add');

    console.log('add');
  }

  async loadData(building_id: string) {
    const biz = new AdminService();
    const response = await biz.getAdminUsers(building_id);
    this.adminRows = response.data;
  }

  detail(row: any) {
    const dialog = this.$refs['admin_detail_dialog'] as AdminInfoMaintenance;
    dialog.show(row, 'detail');
  }

  cancel() {
    const dialog = this.$refs['admin_detail_dialog'] as AdminInfoMaintenance;
    dialog.hide();
  }

  mounted() {
    this.loadData('da01').then();
  }

  @Watch('adminRows')
  pageChanged(rows: any[]) {
    console.log(rows);
    this.dispRows = rows;
  }

  passwordChange(row: AdminDTO) {
    console.log(row);
  }

  added(info: AdminDTO) {
    this.adminRows.splice(0, 0, info);
  }

  updatedInfo(info: AdminDTO) {
    const index = this.adminRows.findIndex((i) => i.userAuth.user_id === info.userAuth.user_id);
    this.adminRows.splice(index, 1, info);
  }

  sortBy(up: boolean, target: string) {
    console.log(target, up);
    this.adminRows = this.adminRows.sort(Sorter.compareByPath(target, up));
  }

  deleted(user_id: string) {
    console.log('user_id', user_id);
    const index = this.dispRows.findIndex((t) => {
      return t.userAuth.user_id === user_id;
    });
    this.dispRows.splice(index, 1);
  }
}
